import {env} from '../util/environment';

export const domains = {
	apiDomain: env.REACT_APP_API_DOMAIN,
	legacyFvDomain: env.REACT_APP_LEGACY_FV_DOMAIN,
	bartDomain: env.REACT_APP_BART_DOMAIN,
	cmsDomain: env.REACT_APP_CMS_DOMAIN,
	mmmDomain: env.REACT_APP_MMM_DOMAIN,
	kuiDomain: env.REACT_APP_KUI_DOMAIN,
	statusDomain: env.REACT_APP_STATUS_DOMAIN,
	alertsDomain: env.REACT_APP_ALERTS_DOMAIN,
	analyticsDomain: env.REACT_APP_ANALYTICS_DOMAIN
};
